module.exports = __webpack_public_path__ + "media/icons/cash-5f0693fe.svg";